/* eslint-disable no-unused-vars */
export default {
    init () {

        if (window.addEventListener) {
            // For standards-compliant web browsers
            window.addEventListener("message", this.processCordovaWrapperMessage, false);
        }
        else {
            window.attachEvent("onmessage", this.processCordovaWrapperMessage);
        }

    },
    processCordovaWrapperMessage(evt)
    {
        window.$vue.$log.info("Enter method processCordovaWrapperMessage");
        var message = evt.data;
	
        if (!message.indexOf) return;

        window.$vue.$log.info("From cordova " + message);

        if (message.indexOf("NE_BACKBUTTON")==0){
            window.$vue.$emit('ne_backbutton');
        }else if(message.indexOf("CONNECTION:TYPE")==0){
           window.$vue.$emit('connection:type', message.substring(16,message.length));
        }else if(message.indexOf("BARCODE:SCAN")==0){
           window.$vue.$emit('barcode:scan', message.substring(13,message.length));
        }else if(message.indexOf("CAMERA:CAPTURE")==0){
            window.$vue.$emit('camera:capture', message.substring(15,message.length));
        }else if(message.indexOf("NE_AWAKE")==0){
           window.$vue.$emit('ne_awake');
        }
    },
    sendCordovaWrapperMessage(message)
    {
        parent.postMessage(message, "*");
        window.$vue.$log.info(message);
    },
    initCompleted () {
        this.sendCordovaWrapperMessage('INIT_COMPLETED');
    },
    getNetworkUpdate() {
        this.sendCordovaWrapperMessage('CONNECTION:UPDATE');
    },
    sendBarcodeScan(){
        var confi = {
              preferFrontCamera : false, // iOS and Android
              showFlipCameraButton : true, // iOS and Android
              showTorchButton : true, // iOS and Android
              torchOn: false, // Android, launch with the torch switched on (if available)
              saveHistory: true, // Android, save scan history (default false)
              prompt : "Place a barcode inside the scan area", // Android
              resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
              formats : "QR_CODE,PDF_417,CODE_128", // default: all but PDF_417 and RSS_EXPANDED
              orientation : "default", // Android only (portrait|landscape), default unset so it rotates with the device
              disableAnimations : true, // iOS
              disableSuccessBeep: false, // iOS and Android
              continuousMode: true // Android
          }
          var res=JSON.stringify(confi);
        this.sendCordovaWrapperMessage('BARCODE:SCAN:'+res);

        //For testing
        //var message = "BARCODE:SCAN:{\"Result\":\"textodelcodigodebarras\", \"Format\":\"formatoDeCodigoDeBarras\" , \"Cancelled\":\"false\"}"
        //var message = "CONNECTION:TYPE:WiFi"
        //window.$vue.$emit('connection:type', message.substring(16,message.length));
        //window.$vue.$emit('ne_backbutton');

    },

    sendCapturePicture(){
        var confi = {
              quality:70
          }
          var res=JSON.stringify(confi);
        this.sendCordovaWrapperMessage('CAMERA:CAPTURE:'+res);

        //For testing
        //var message = "BARCODE:SCAN:{\"Result\":\"textodelcodigodebarras\", \"Format\":\"formatoDeCodigoDeBarras\" , \"Cancelled\":\"false\"}"
        //var message = "CONNECTION:TYPE:WiFi"
        //window.$vue.$emit('connection:type', message.substring(16,message.length));
        //window.$vue.$emit('ne_backbutton');

    }
}